import { useGT } from 'gt-react';
import { Checkbox } from '@/components/ui/checkbox';
import type { EmailComposerContact, RecipientRole } from './types';

interface ContactRowProps {
  contact: EmailComposerContact;
  role: RecipientRole | undefined;
  onToggle: () => void;
  onToggleRole: () => void;
}

export function ContactRow({
  contact,
  role,
  onToggle,
  onToggleRole,
}: ContactRowProps) {
  const gt = useGT();
  const isSelected = role != null;
  return (
    <label
      htmlFor={`email-composer-contact-${contact.id}`}
      className="flex flex-wrap items-center gap-x-3 gap-y-1 px-3 py-2 cursor-pointer hover:bg-muted/50"
    >
      {isSelected ? (
        role === 'bcc' ? (
          <span
            className="rounded bg-purple-100 text-purple-800 px-1.5 py-0.5 text-xs font-medium shrink-0 min-w-[28px] text-center"
            title={gt('Assigned to BCC; uncheck to remove', {
              context: 'tooltip for bcc-assigned contact pill',
            })}
          >
            {gt('BCC', { context: 'email blind carbon copy role label' })}
          </span>
        ) : (
          <button
            type="button"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onToggleRole();
            }}
            className={`rounded px-1.5 py-0.5 text-xs font-medium shrink-0 cursor-pointer min-w-[28px] text-center ${
              role === 'to'
                ? 'bg-blue-100 text-blue-800 hover:bg-blue-200'
                : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
            }`}
            title={
              role === 'to'
                ? gt('Click to change to CC', {
                    context: 'tooltip for email role toggle button',
                  })
                : gt('Click to change to To', {
                    context: 'tooltip for email role toggle button',
                  })
            }
          >
            {role === 'to'
              ? gt('To', { context: 'email recipient role label' })
              : gt('CC', { context: 'email carbon copy role label' })}
          </button>
        )
      ) : (
        <div className="min-w-[28px]" />
      )}
      <Checkbox
        id={`email-composer-contact-${contact.id}`}
        checked={isSelected}
        onCheckedChange={onToggle}
      />
      <span className="text-sm font-medium">{contact.email}</span>
      {contact.tags.map((tag) => (
        <span
          key={tag}
          className="rounded bg-muted px-1.5 py-0.5 text-xs text-muted-foreground shrink-0"
        >
          {tag}
        </span>
      ))}
    </label>
  );
}
